import React from 'react';
import CardGeneralContainer from '../containers/CardGeneralContainer';
import CardClientBrandContainer from '../containers/CardClientBrandContainer';
import CardDSPScreensContainer from '../containers/CardDSPScreensContainer';
import CartInitialBudgetContainer from '../containers/CartInitialBudgetContainer';
import LeftSideStyleHolder from './Styles/leftSideStyle';
import { Button, Icon } from "antd";
import { useTranslation } from 'react-i18next';
import ModalInfoNewViewComponent from "./ModalInfoNewViewComponent";
import CardCampaignStatusContainer from '../containers/CardCampaignStatusContainer';
import { getDomain } from '../services/utils';

const LeftSideComponent = ({
  stepsCurrent,
  updateByAmountBudget,
  cart,
  customContents,
  updateRealAmount,
  viewCampaignPayment,
  editCampaignActive,
  currentCampaign,
  editingCampaign,
  prevSteps,
  history
}) => {

  const { t } = useTranslation();
  const [visibleVideoModal, setVisibleVideoModal] = React.useState(false);
  const domain = getDomain(window.location.hostname);

  const showVideoModal = () => {
    setVisibleVideoModal(!visibleVideoModal);
  };

  const getButtonConfig = () => {
    if (stepsCurrent > 0) {
      return {
        visible: true,
        text: t("Go back"),
        icon: 'arrow-left',
        action: prevSteps,
        disabled: editingCampaign
      };
    }

    let btnText = t("Map");
    let btnIcon = 'left';

    let btnAction = prevSteps;

    if (editCampaignActive) {
      btnText = t("Go back");
    }

    if (viewCampaignPayment && stepsCurrent === 0) {
      btnAction = () => history.push(`/map`);
    }

    return {
      visible: true,
      text: btnText,
      icon: btnIcon,
      action: btnAction,
      disabled: editingCampaign
    };
  };

  const backButton = getButtonConfig();

  const { is_guaranteed, programmatic_provider_id } = currentCampaign || {};

  return (
    <LeftSideStyleHolder>
      <div className="leftSideContainer">

        {backButton.visible && (
          <Button
            className={`goBackButtons ${domain === 'dv360' ? 'dv360' : ''}`}
            onClick={backButton.action}
            disabled={backButton.disabled}
          >
            <Icon type={backButton.icon} />
            <span style={{ textTransform: "capitalize", marginLeft: 8 }}>
              {backButton.text}
            </span>
          </Button>
        )}

        <div className="leftSideCards">
          {stepsCurrent !== 2 && stepsCurrent !== 3 && (
            <>
              <CartInitialBudgetContainer
                stepsCurrent={stepsCurrent}
                updateByAmountBudget={updateByAmountBudget}
                cart={cart}
                customContents={customContents}
                updateRealAmount={updateRealAmount}
              />

              <CardGeneralContainer stepsCurrent={stepsCurrent} />

              {currentCampaign && (
                <CardCampaignStatusContainer currentCampaign={currentCampaign} />
              )}

              <CardClientBrandContainer stepsCurrent={stepsCurrent} />

              <CardDSPScreensContainer
                stepsCurrent={stepsCurrent}
                is_guaranteed={is_guaranteed}
                programmatic_provider_id={programmatic_provider_id}
              />
            </>
          )}

          {stepsCurrent === 3 && currentCampaign && (
            <CardCampaignStatusContainer currentCampaign={currentCampaign} />
          )}

          {stepsCurrent === 0 && (
            <>
              <Button className={`guideButton ${domain === 'dv360' ? 'dv360' : ''}`} onClick={showVideoModal}>
                {t("View guide")}
              </Button>

              <ModalInfoNewViewComponent
                onCancel={showVideoModal}
                visible={visibleVideoModal}
                showMainModal={false}
              />
            </>
          )}
        </div>
      </div>
    </LeftSideStyleHolder>
  );
};

export default LeftSideComponent;
